import { render, staticRenderFns } from "./InformationCompany.vue?vue&type=template&id=4d519ab6&"
import script from "./InformationCompany.vue?vue&type=script&lang=ts&"
export * from "./InformationCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports